import { createRouter, createWebHistory } from "vue-router";
import Domains from "./views/Domains.vue";
import { NtaNotFound } from "@lr-notitia/notitia-ui/components";
import datatypeRoutes from "./modules/datatypes/router";
import informationModelRoutes from "./modules/information-model/router";
import expertKnowledgeRoutes from "./modules/expert-knowledge/router";

const routes = [
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: NtaNotFound,
	},
	{
		path: "/",
		name: "Domains",
		component: Domains,
	},
	{
		path: "/:domainId",
		redirect: (to: any) => `/${to.params.domainId}/information-model`,
	},
	...datatypeRoutes,
	...informationModelRoutes,
	...expertKnowledgeRoutes,
];

export default createRouter({
	history: createWebHistory(),
	routes,
});
